

const { default: RHFAutocomplete } = require("../components/RHFAutocomplete");
const { default: RHFDatePicker } = require("../components/RHFDatePicker");
const { default: RHFDropdown } = require("../components/RHFDropdown");
const { default: RHFMultiselectDropdown } = require("../components/RHFMultiselectDropdown");
const { default: RHFTextField } = require("../components/RHFTextField");
const { default: RHFFileUpload } = require("../components/RHFFileUpload");
const { default: RHFCheckbox } = require("../components/RHFCheckbox");
const { default: RHFRadioButton } = require("../components/RHFRadioGroup");


export const renderControls = (field, index, control, getDataFunc, reset) => {

    switch (field.DataType) {
        case "Textbox":
            return <RHFTextField key={`${index}${reset}`} formData={field} control={control} />;
        case "MultiselectDropdown":
            return (
                <RHFMultiselectDropdown
                    key={`${index}${reset}`}
                    formData={field}
                    control={control}
                />
            );
        case "Dropdown":
            return <RHFDropdown key={`${index}${reset}`} formData={field} control={control} />;
        case "Autocomplete":
            return <RHFAutocomplete key={`${index}${reset}`} formData={field} control={control} getDataFunc={getDataFunc} />;
        case "Date":
            return <RHFDatePicker key={`${index}${reset}`} formData={field} control={control} />;
        case "UploadFile":
        case "File":
            return <RHFFileUpload key={`${index}${reset}`} formData={field} control={control} />;
        case 'CheckBox':
            return <RHFCheckbox key={`${index}${reset}`} formData={field} control={control} />;
        case 'RadioButton':
            return <RHFRadioButton key={`${index}${reset}`} formData={field} control={control} />;
        default:
            return null;
    }
};